module.exports = __webpack_public_path__ + "img/next.8a4fa5c4.svg";